module.exports = __webpack_public_path__ + "img/task3.524e70e2.png";